/**
 * SourceTag — small chip showing a source tier (icon + label).
 *
 * Used inline next to AI prose to indicate where a claim comes from, and as
 * section headers in <SourceList>.
 */
import styled from '@emotion/styled';
import { getTier } from './tiers';
import { useTranslation } from '../../hooks/useTranslation';

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  background: ${p => p.$bg};
  color: ${p => p.$color};
  border: 1px solid ${p => p.$border};
  white-space: nowrap;
  flex-shrink: 0;
`;

const Count = styled.span`
  font-weight: 700;
  opacity: 0.7;
`;

export default function SourceTag({ tier = 'rag', count, label }) {
  const { t } = useTranslation();
  const meta = getTier(tier);
  const Icon = meta.icon;
  return (
    <Chip $bg={meta.bg} $color={meta.color} $border={meta.border}>
      <Icon size={12} strokeWidth={2.2} />
      {label || t(meta.labelKey)}
      {typeof count === 'number' && <Count>({count})</Count>}
    </Chip>
  );
}
